// eslint-disable-next-line import/prefer-default-export
export const unityApiMap = {
  INTERACTION_STATUS: '/v1/interaction',
  INTERACTION_INIT: '/v1/interaction/init',
};
